// Buttons for snippets/pg-product-card.liquid.

// "Order Now": add one item to the cart, then go straight to checkout.
if (!customElements.get('pg-card-order')) {
  customElements.define(
    'pg-card-order',
    class PgCardOrder extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        if (!this.link) return;
        this.link.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        // Let modifier-clicks (new tab etc.) use the cart permalink as-is
        if (event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        if (this.link.classList.contains('is-loading')) return;
        this.link.classList.add('is-loading');

        fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(this.dataset.variantId), quantity: 1 }] }),
        })
          .then((response) => {
            if (!response.ok) throw new Error('Add to cart failed');
            window.location.href = `${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}checkout`;
          })
          .catch(() => {
            // Fall back to the cart permalink, which also opens checkout
            window.location.href = this.link.href;
          });
      }
    }
  );
}

// "Add to Cart": shows Trade's cart notification when present, otherwise refreshes the cart count bubble.
if (!customElements.get('pg-card-cart')) {
  customElements.define(
    'pg-card-cart',
    class PgCardCart extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.button.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        event.preventDefault();
        if (this.button.disabled || this.button.classList.contains('is-loading')) return;

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const sections = cart && cart.getSectionsToRender ? cart.getSectionsToRender().map((s) => s.id) : [];
        if (!sections.includes('cart-icon-bubble')) sections.push('cart-icon-bubble');

        if (cart && cart.setActiveElement) cart.setActiveElement(this.button);
        this.button.classList.add('is-loading');

        fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(this.dataset.variantId), quantity: 1 }],
            sections: sections,
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((state) => {
            if (state.status) throw new Error(state.description || state.message);

            // /cart/add.js with `items` returns { items: [...], sections }; cart-notification expects a single item shape
            const item = state.items ? state.items[0] : state;
            const parsedState = Object.assign({}, item, { sections: state.sections });

            if (cart && cart.renderContents) {
              cart.renderContents(parsedState);
            } else {
              this.renderBubble(state.sections);
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pg-product-card', productVariantId: this.dataset.variantId });
            }
            this.flash();
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.button.classList.remove('is-loading');
          });
      }

      renderBubble(sections) {
        const bubble = document.getElementById('cart-icon-bubble');
        if (!bubble || !sections || !sections['cart-icon-bubble']) return;
        const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const source = html.querySelector('.shopify-section') || html.body;
        bubble.innerHTML = source.innerHTML;
      }

      flash() {
        const label = this.button.querySelector('.pg-card__cart-label');
        const original = label ? label.textContent : '';
        this.button.classList.add('is-added');
        if (label) label.textContent = this.button.dataset.addedText;
        setTimeout(() => {
          this.button.classList.remove('is-added');
          if (label) label.textContent = original;
        }, 2000);
      }
    }
  );
}
